import {ExcelCommonHelper} from '@shared/helpers/excel/excel-common.helper';
import {ExcelTab} from '@shared/helpers/excel/excel.interfaces';
import {Workbook} from 'exceljs';
import {saveAs} from 'file-saver-es';

/**
 * 'ExportExcelService' class definition.
 */
export class ExportExcelService {
	/**
	 * Exports the provided table data to an Excel file.
	 * This method creates a new workbook, generates a worksheet with the provided data,
	 * and initiates the download of the Excel file.
	 * @param {ExcelTab[]} tabs
	 * @param {string} fileName
	 * @returns {void}
	 */
	public static exportFile(tabs: ExcelTab[], fileName: string): void {
		// Create file
		const workbook = new Workbook();

		tabs.forEach((tab) => {
			const columnsConfig = tab.columns;
			ExcelCommonHelper.generateWorksheet(workbook, tab, columnsConfig);
		});

		// Start downloading
		ExportExcelService.download(workbook, fileName);
	}

	/**
	 * Initiates the download of the generated Excel workbook.
	 * This method converts the workbook to a binary buffer and triggers the download
	 * using the specified filename, which includes the title and date range if available.
	 * @param {Workbook} workbook
	 * @param {string} fileName
	 * @returns {void}
	 */
	private static download(workbook: Workbook, fileName: string): void {
		workbook.xlsx.writeBuffer().then(
			(buffer) => {
				saveAs(new Blob([buffer], {type: 'application/octet-stream'}), fileName);
			},
			() => console.warn('download failed')
		);
	}
}
